export default __webpack_public_path__ + "static/media/home-9.f6317809.jpg";